import { useState } from 'react'
import { Icon } from './Icon'
import { useDialog } from '../useDialog'

export function MergeConflictView({
  paths,
  busy,
  onResolve,
  onClose,
}: {
  paths: string[]
  busy: boolean
  onResolve: (choices: Record<string, 'draft' | 'main'>) => void
  onClose: () => void
}) {
  const [choices, setChoices] = useState<Record<string, 'draft' | 'main'>>({})
  const remaining = paths.filter((path) => choices[path] === undefined).length
  const panel = useDialog<HTMLElement>(true, onClose)

  return (
    <div className="scrim" onMouseDown={onClose}>
      <aside
        className="drawer drawer--wide"
        ref={panel}
        role="dialog"
        aria-modal="true"
        aria-label="Resolve merge conflicts"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header className="drawer__head">
          <div>
            <h2 className="drawer__title">Rebase this draft onto main</h2>
            <p className="drawer__sub">Another draft changed the same lines first.</p>
          </div>
          <button className="btn btn--ghost btn--icon" onClick={onClose}>
            <Icon name="close" size={15} label="Close" />
          </button>
        </header>
        <div className="drawer__body">
          <section className="drawer__block">
            <p className="drawer__hint">
              The merge was refused before any work changed. Choose the starting version for every
              file. Keeping the draft stages its version again on top of current main; either choice
              requires a new commit and review.
            </p>
            <ul className="filelist">
              {paths.map((path) => (
                <li className="filelist__row" key={path}>
                  <span className="filelist__path mono">{path}</span>
                  <label>
                    <input
                      type="radio"
                      name={`merge-${path}`}
                      checked={choices[path] === 'draft'}
                      onChange={() => setChoices((now) => ({ ...now, [path]: 'draft' }))}
                    />{' '}
                    Keep draft
                  </label>
                  <label>
                    <input
                      type="radio"
                      name={`merge-${path}`}
                      checked={choices[path] === 'main'}
                      onChange={() => setChoices((now) => ({ ...now, [path]: 'main' }))}
                    />{' '}
                    Keep main
                  </label>
                </li>
              ))}
            </ul>
          </section>
        </div>
        <footer className="drawer__foot">
          <div className="drawer__actions">
            <button
              className="btn btn--primary"
              disabled={busy || remaining > 0}
              onClick={() => onResolve(choices)}
            >
              {remaining > 0 ? `${remaining} still to decide` : 'Rebase with these choices'}
            </button>
            <button className="btn btn--ghost" disabled={busy} onClick={onClose}>
              Decide later
            </button>
          </div>
        </footer>
      </aside>
    </div>
  )
}
